module.exports = __webpack_public_path__ + "static/media/pov_highlight_face_GreatStellatedDodecahedron.c73f4708.png";